<!--
 * @Author: gaojingran
 * @Date: 2021-04-07 16:29:00
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-07-29 16:08:49
 * @Description: 创建订单
-->
<style lang="less" scoped>
.new-order {
  padding: 10px 20px 20px;
  /deep/.ant-form-item {
    display: flex;
  }
  .button-wrapper {
    padding-left: 80px;
  }
}
</style>

<template>
  <NeoPageLayout>
    <a-spin :spinning="loading">
      <div class="new-order">
        <h1 class="mt-4 mb-4 fs-6">{{ $t('newOrder.title') }}</h1>
        <!-- step 1 -->
        <template v-if="step === 1">
          <NeoUploadDragger
            v-model="sourceFileList"
            sortType="unshift"
            :accept="acceptMap.orderSourceFile"
            :maxLength="20"
            :maxSize="200"
          />
          <a-button
            v-if="sourceFileList.length"
            class="mt-4"
            type="primary"
            :disabled="setpOneButtonDisable"
            @click="step = 2"
            >{{ $t('next') }}</a-button
          >
        </template>
        <!-- step 2 -->
        <template v-if="step === 2">
          <div class="order-form">
            <a-form-model ref="orderForm" v-bind="formLayout" :colon="false" :model="form" :rules="rules">
              <a-row :gutter="20">
                <a-col :span="12">
                  <a-form-model-item prop="name" :label="$t('newOrder.order_name')">
                    <a-input
                      allowClear
                      autocomplete="off"
                      :defaultValue="form.name"
                      :placeholder="$t('newOrder.order_name_holder')"
                      @blur="handleInputBlur($event, 'name')"
                    />
                  </a-form-model-item>
                </a-col>

                <a-col :span="12">
                  <a-form-model-item prop="productLineId" :label="$t('newOrder.product_line')">
                    <a-select
                      allowClear
                      show-search
                      :filter-option="labelFilterOption"
                      v-model="form.productLineId"
                      :placeholder="$t('newOrder.product_line_holder')"
                    >
                      <a-select-option v-for="item in productLineList" :key="item.id" :value="item.id">
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>

                <a-col :span="12">
                  <a-form-model-item prop="sourceCode" :label="$t('newOrder.source')">
                    <a-select
                      allowClear
                      show-search
                      option-filter-prop="children"
                      v-model="form.sourceCode"
                      :filter-option="langFilterOption"
                      :placeholder="$t('newOrder.source_holder')"
                    >
                      <a-select-option
                        v-for="item in sourceCodeList"
                        :key="item.code"
                        :value="item.code"
                        :disabled="form.targetCodeList.includes(item.code)"
                      >
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>

                <a-col :span="12">
                  <a-form-model-item prop="targetCodeList" :label="$t('newOrder.target')">
                    <a-select
                      allowClear
                      mode="multiple"
                      :maxTagTextLength="20"
                      :token-separators="[',']"
                      v-model="form.targetCodeList"
                      @change="handleTargetCodeChange"
                      :filter-option="langFilterOption"
                      :placeholder="$t('newOrder.target_holder')"
                    >
                      <a-select-option
                        v-for="item in targetCodeList"
                        :key="item.code"
                        :value="item.code"
                        :disabled="form.sourceCode === item.code"
                      >
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>

                <a-col :span="12">
                  <a-form-model-item required :label="$t('newOrder.service_type')" style="margin-bottom: 0">
                    <a-row type="flex">
                      <a-col flex="auto">
                        <a-form-model-item prop="serviceType" :wrapperCol="{ span: 24 }">
                          <a-select
                            allowCler
                            v-model="form.serviceType"
                            :placeholder="$t('newOrder.service_type_holder')"
                          >
                            <a-select-option v-for="item in serviceTypeList" :key="item.id" :value="item.id">
                              {{ item.label }}
                            </a-select-option>
                          </a-select>
                        </a-form-model-item>
                      </a-col>

                      <a-col flex="150px">
                        <a-form-model-item class="fr" prop="fine" :wrapperCol="{ span: 24 }">
                          <a-checkbox v-model="form.composeType">
                            {{ $t('newOrder.fine') }}
                          </a-checkbox>
                          <a-tooltip placement="top" :title="$t('newOrder.fine_tip')">
                            <a-icon type="question-circle" />
                          </a-tooltip>
                        </a-form-model-item>
                      </a-col>
                    </a-row>
                  </a-form-model-item>
                </a-col>

                <a-col :span="12">
                  <a-form-model-item required prop="supplierId" :label="$t('newOrder.supplier')">
                    <a-select
                      showArrow
                      allowClear
                      v-model="form.supplierId"
                      :placeholder="$t('newOrder.supplier_holder')"
                    >
                      <a-select-option v-for="item in supplierList" :key="item.supEntityId" :value="item.supEntityId">
                        {{ item.supEntityName }}
                        <span v-if="item.isRecommend"><img src="@/assets/image/recommend.png" /> </span>
                      </a-select-option>
                    </a-select>
                    <div style="color: red; line-height: 25px" v-if="supplierTipShow2">
                      {{
                        $t('validate.supplier_info', {
                          s: getCodeName(form.sourceCode),
                          t: getCodesName(invalidTargetCodeList),
                          documentType: getDocTypeName(form.documentType),
                          serviceType: getTypeName(form.serviceType),
                        })
                      }}
                    </div>
                  </a-form-model-item>
                </a-col>

                <a-col :span="12">
                  <a-form-model-item prop="documentType" :label="$t('newOrder.doc_type')">
                    <a-select allowClear v-model="form.documentType" :placeholder="$t('newOrder.doc_type_holder')">
                      <a-select-option v-for="item in documentTypeList" :key="item.id" :value="item.id">
                        {{ item.label }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>

                <a-col :span="12">
                  <a-form-model-item prop="dueDate" :label="$t('newOrder.delivery_date')">
                    <a-date-picker
                      style="width: 100%"
                      allowCler
                      valueFormat="YYYY-MM-DD HH:mm:00"
                      v-model="form.dueDate"
                      :showTime="timePickerOption"
                      :format="$t('dateFormat.a')"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <a-form-model-item prop="remark" :label="$t('newOrder.order_note')">
                    <a-textarea
                      style="width: 100%"
                      :defaultValue="form.remark"
                      :placeholder="$t('newOrder.order_note_holder')"
                      :auto-size="{ minRows: 3, maxRows: 5 }"
                      @blur="handleInputBlur($event, 'remark')"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="24">
                  <a-form-model-item prop="attachment" style="margin-bottom: 0">
                    <div style="padding-left: 80px">
                      <NeoUploadDragger
                        fileType="tag"
                        v-model="form.attachmentFileList"
                        sortType="unshift"
                        :placeholder="$t('uploadDragger.upload_attachment_file')"
                        :accept="acceptMap.orderAttachmentFile"
                        :defaultCollapsed="true"
                        :collapsible="false"
                        :maxLength="5"
                        :maxSize="10"
                      />
                    </div>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-form-model>
            <!-- button -->
            <div class="button-wrapper" :class="!form.attachmentFileList.length ? 'mt-4' : 'mt-1'">
              <a-space :size="10">
                <a-button class="neo-btn-primary" @click="step = 1">
                  {{ $t('prev') }}
                </a-button>
                <a-button class="neo-btn-primary" @click="handleSaveDraft">
                  {{ $t('newOrder.save_draft') }}
                </a-button>
                <!-- <a-button type="primary" :disabled="true">{{ $t('newOrder.auto_quote') }}</a-button> -->
                <a-button type="primary" @click="handleGetQuote">
                  {{ $t('newOrder.get_quote') }}
                </a-button>
                <NeoTips :label="$t('newOrder.note_label')" :text="$t('newOrder.note_desc')" />
              </a-space>
            </div>
          </div>
        </template>
      </div>
    </a-spin>
  </NeoPageLayout>
</template>

<script>
import { mapState } from 'vuex'
import { Icon } from 'ant-design-vue'
import NeoUploadDragger from '@/components/upload/NeoUploadDragger'
import NeoTips from '@/components/common/NeoTips'
import { uuid } from '@/utils/utils'

const { validate, acceptMap } = window.$g

export default {
  name: 'NewOrder',
  components: {
    NeoUploadDragger,
    NeoTips,
  },
  data() {
    return {
      // 供应商列表
      supplierList: [],
      loading: false,
      acceptMap,
      step: 1,
      formLayout: {
        labelCol: { flex: '80px' },
        wrapperCol: { flex: 'auto' },
      },
      timePickerOption: {
        format: 'HH:mm',
      },
      // 产线
      productLineList: [],
      // 翻译文件
      sourceFileList: [],
      // 订单表单
      form: {
        productLineId: undefined,
        sourceCode: undefined,
        targetCodeList: [],
        name: '',
        dueDate: undefined,
        serviceType: undefined,
        documentType: undefined,
        composeType: false, // 排版类型 0-简排 1-精排
        attachmentFileList: [],
        remark: '',
        supplierId: undefined,
      },
      // 表单验证
      rules: {
        productLineId: [validate.required],
        dueDate: [validate.earlier_time],
        sourceCode: [validate.required],
        targetCodeList: [validate.required],
        name: [{ ...validate.required, trigger: 'blur' }, validate.length_3_50],
        documentType: [validate.required],
        serviceType: [validate.required],
        remark: [validate.size_1000],
        supplierId: [validate.required],
      },
      // -----------------
      serviceTypeList: [],
      documentTypeList: [],
      // ------
      sourceCodeList: [],
      targetCodeList: [],
      validList: [],
      supPairMap: [],
      sourceCodeListInit: [],
      targetCodeListInit: [],
      mappingLangPair: [],
      supplierTipShow: false,
    }
  },
  computed: {
    // 步骤一按钮禁用状态
    setpOneButtonDisable() {
      // 当文件不存在合法 以及 存在正在上传的文件
      const validFile = this.sourceFileList.find((v) => v.status === 'uploading')
      return this.$is.Defined(validFile)
    },

    // 语言列表
    ...mapState('app', {
      langList: (state) => state.langList,
      userInfo: (state) => state.userInfo,
    }),
    entityId() {
      return this.$store.state.app.userInfo.agencyId
    },
    supplierInfo() {
      const f = this.form
      const result = !!(
        f.serviceType &&
        f.supplierId &&
        f.sourceCode &&
        f.targetCodeList.length &&
        this.supplierTipShow
      )
      return result
    },
    invalidTargetCodeList() {
      const f = this.form
      const needShowCheck = !!(
        f.serviceType &&
        f.documentType &&
        f.supplierId &&
        f.sourceCode &&
        f.targetCodeList.length
      )
      if (!needShowCheck) return []

      const validPair = this.supPairMap[f.supplierId]
      if (!validPair) return [...f.targetCodeList]

      const validTarget = validPair
        .filter((p) => p.serviceId === f.serviceType && p.documentId === f.documentType)
        .filter((p) => p.sourceCode === f.sourceCode)
        .filter((p) => f.targetCodeList.includes(p.targetCode))
        .map((p) => p.targetCode)
      return f.targetCodeList.filter((t) => !validTarget.includes(t))
    },
    supplierTipShow2() {
      return this.invalidTargetCodeList.length > 0
    },
  },
  watch: {
    'form.productLineId': {
      deep: true,
      handler() {
        this.getSupList()
      },
    },
    'form.sourceCode': {
      deep: true,
      handler(code) {
        console.log(code)
        if (code) {
          // item[0]=>obj  item[1]=>obj_arr
          // 修改目标语言下拉列表
          console.log(`this.mappingLangPair`, this.mappingLangPair)
          const target = (this.mappingLangPair.find((item) => {
            console.log(`item`, item)
            return item[0].code === code
          }) || [])[1]
          console.log(`target`, target)
          this.targetCodeList = target
          // const sourceCodeList = this.sourceCodeListInit.find((item) => item.code === code)
          // this.sourceCodeList = sourceCodeList
        } else {
          console.log('源语言被清空')
          this.targetCodeList = this.targetCodeListInit
        }
        this.getSupList()
        this.updateSupMatchTip()
      },
    },
    'form.targetCodeList': {
      deep: true,
      handler(codes) {
        console.log(codes)
        if (codes.length) {
          // 修改目标语言下拉列表
          const target = this.mappingLangPair.filter((item) => {
            // console.log(`item`, item)
            const codes1 = item[1].map((_item) => _item.code)
            const result = this.$g.includes(codes, codes1)
            // console.log('---------↓---------')
            // console.log(`codes1`, codes1)
            // console.log(`codes2`, codes2)
            // console.log(`result`, result)
            // console.log('---------↑---------')

            return result
          })
          let _target = []
          if (target.length) {
            _target = target.map((item) => {
              console.error(`item`, item)
              return item[0]
            })
          }
          console.log(`_target`, _target)
          this.sourceCodeList = _target
        } else {
          this.sourceCodeList = this.sourceCodeListInit
          console.log('目标语言被清空')
        }
        this.getSupList()
        this.updateSupMatchTip()
      },
    },
    'form.supplierId': {
      deep: true,
      handler() {
        this.updateSupMatchTip()
      },
    },
    productLineList(arr) {
      if (arr.length === 1) {
        this.form.productLineId = arr[0].id
      }
    },
    supplierList(arr) {
      if (arr.length === 1) {
        this.form.supplierId = arr[0].supEntityId
      }
    },
  },
  mounted() {
    this.fetchAll()
  },
  methods: {
    updateSupMatchTip() {
      const supplierId = this.form.supplierId
      const currentLangPair = this.form.sourceCode + '-' + this.form.targetCodeList.join(',')
      if (!(this.form.sourceCode && this.form.targetCodeList.length && supplierId)) {
        this.supplierTipShow = false
        return
      }
      const supPairArr = this.$g.flatten(
        Object.keys(this.supPairMap)
          .map((id) => {
            if (id === supplierId) {
              const str_arr = this.supPairMap[id].map(({ sourceCode, targetCode }) => {
                return sourceCode + '-' + targetCode
              })
              return str_arr
            }
          })
          .filter(Boolean)
      )
      if (!supPairArr.length || supPairArr.excludes(currentLangPair)) {
        this.supplierTipShow = true
      } else {
        this.supplierTipShow = false
      }
    },
    getCodeName(code = '') {
      return this.$store.getters['app/getLangNameByCode'](code) || '---'
    },
    getCodesName(codes = []) {
      console.log(`codes`, codes)
      const result = codes.map((code) => {
        return this.$store.getters['app/getLangNameByCode'](code)
      })
      console.error(`result`, result)
      return result || '---'
    },
    getTypeName(id = '') {
      return this.serviceTypeList.find((item) => item.id === id).label
    },
    getDocTypeName(id = '') {
      return this.documentTypeList.find((item) => item.id === id)?.label
    },
    handleLangPairData(validList) {
      const arrs = this.$g.sortClass(validList, 'sourceCode')
      const mappingLangPair = arrs.map((arr) => {
        // arr的每个sourceCode都是一样的，只有targetCode不一样
        // 输出的格式：[{code:'zh_CN'...},[{code:jp_JP...},{name:en_US...}] ]
        const sourceCode = this.langList.find((item) => item.code === arr[0].sourceCode)
        const targetCodes = arr
          .map((a) => a.targetCode)
          .filter(Boolean)
          .map((code) => {
            const _item = this.langList.find((item) => item.code === code)
            return _item
          })

        const item = [sourceCode, targetCodes]
        return item
      })
      const sourceCodeListInit = mappingLangPair.map((item) => item[0])
      const targetCodeListInit = this.$g.flatten(mappingLangPair.map((item) => item[1]))
      this.mappingLangPair = mappingLangPair
      this.sourceCodeListInit = sourceCodeListInit
      this.targetCodeListInit = targetCodeListInit

      return { sourceCodeListInit, targetCodeListInit }
    },
    async getOrderPairInfo() {
      try {
        const data = await this.$http('getOrderPairInfo')
        let sourceCodeList = []
        let targetCodeList = []
        const { validList, supPairMap } = data
        this.validList = validList
        this.supPairMap = supPairMap
        if (validList.length) {
          const { sourceCodeListInit, targetCodeListInit } = this.handleLangPairData(validList)
          sourceCodeList = sourceCodeListInit
          targetCodeList = targetCodeListInit
        } else {
          sourceCodeList = this.langList
          targetCodeList = this.langList
        }
        this.sourceCodeList = sourceCodeList
        this.targetCodeList = targetCodeList
      } catch (err) {
        this.$httpNotify(err)
      }
    },
    async orderTemp() {
      try {
        const data = await this.$http('orderTemp')
        console.error(`data`, data)
        if (!data) {
          return
        }
        const {
          productLineId,
          sourceCode,
          targetCodeList,
          name,
          dueDate,
          serviceType,
          documentType,
          composeType,
          sourceFileList,
          remark,
          supplierId,
        } = data

        this.sourceFileList = sourceFileList || []

        console.error('this.supplierList :>> ', this.supplierList)

        this.form = {
          productLineId: productLineId || undefined,
          sourceCode: sourceCode || undefined,
          targetCodeList: targetCodeList ? targetCodeList.split(',') : [],
          name: name || undefined,
          dueDate: dueDate || undefined,
          serviceType: serviceType || undefined,
          documentType: documentType || undefined,
          remark: remark || undefined,
          supplierId,
          composeType: Boolean(composeType),
          attachmentFileList: this.form.attachmentFileList,
        }
        this.loading = false
        console.error('this.form :>> ', this.form)
      } catch (err) {
        this.$httpNotify(err)
      }
    },
    // 旧订单作为模板创建新订单
    async orderModel() {
      try {
        this.loading = true

        const data = await this.$http({
          key: 'orderProcessInfo',
          params: {
            id: this.$route.query.modelId,
          },
        })
        const {
          productLineId,
          sourceCode,
          targetCodeList,
          name,
          dueDate,
          serviceType,
          documentType,
          composeType,
          remark,
          supplierId,
        } = data

        this.form = {
          productLineId: productLineId || undefined,
          sourceCode: sourceCode || undefined,
          targetCodeList: targetCodeList ? targetCodeList.split(',') : [],
          name: name || undefined,
          dueDate: dueDate || undefined,
          serviceType: serviceType || undefined,
          documentType: documentType || undefined,
          remark: remark || undefined,
          supplierId,
          composeType: Boolean(composeType),
          attachmentFileList: this.form.attachmentFileList,
        }
        this.loading = false
      } catch (err) {
        this.loading = false
        this.$httpNotify(err)
      }
    },
    fetchAll() {
      this.getCusProductLineList()
      this.getCusServiceTypeList()
      this.getCusDocumentTypeList()
      // 获取供应商列表
      this.getSupList()
      this.getOrderPairInfo()
      if (this.$is.Defined(this.$route.query.id)) {
        this.getInfo()
      } else if (this.$is.Defined(this.$route.query.modelId)) {
        this.orderModel()
      } else {
        this.orderTemp()
      }
    },
    // 客户产品线表-列表
    async getCusProductLineList() {
      try {
        const data = await this.$http('cusProductLineList', { entityId: this.entityId })
        this.productLineList = data
      } catch (err) {
        this.$httpNotify(err)
      }
    },
    // 客户服务类型表-列表
    async getCusServiceTypeList() {
      try {
        const data = await this.$http('cusMaterialList', { entityId: this.entityId, type: 1 })
        // this.serviceTypeList = data
        this.serviceTypeList = data.filter(({ value }) => Number(value) === 1)
      } catch (err) {
        this.$httpNotify(err)
      }
    },
    // 客户文档类型表-列表
    async getCusDocumentTypeList() {
      try {
        const data = await this.$http('cusMaterialList', { entityId: this.entityId, type: 2 })
        this.documentTypeList = data
      } catch (err) {
        this.$httpNotify(err)
      }
    },

    // -----------------↑↑↑---------------------
    langFilterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    handleInputBlur(ev, key) {
      this.form[key] = ev.target.value
    },

    getFormData() {
      return {
        ...this.form,
        targetCodeList: this.form.targetCodeList.join(','),
        composeType: Number(this.form.composeType),
        sourceFileList: this.sourceFileList
          .filter((v) => v.status === 'done')
          .map((v) => ({
            name: v.name,
            url: v.url,
          })),
      }
    },

    //  attachmentFileList: this.form.attachmentFileList
    //     .filter((v) => v.status === 'done')
    //     .map((v) => ({
    //       name: v.name,
    //       url: v.url,
    //     }))

    handleTargetCodeChange() {
      const newArray = []
      const errorArray = []
      this.form.targetCodeList.forEach((code) => {
        const n = this.langList.find((v) => v.name === code)
        const c = this.langList.find((v) => v.code === code)
        if (c) {
          return newArray.push(code)
        }
        if (n) {
          // 假设code为name的话替换为code
          return newArray.push(n.code)
        }
        return errorArray.push(code)
      })
      this.form.targetCodeList = newArray
      if (errorArray.length) {
        this.$message.error(this.$t('newOrder.error_lang_tips', { language: errorArray.join(', ') }))
      }
    },

    // 获取草稿箱详情
    async getInfo() {
      try {
        this.loading = true

        const data = await this.$http({
          key: 'orderProcessInfo',
          params: {
            id: this.$route.query.id,
          },
        })
        const {
          id,
          productLineId,
          sourceCode,
          targetCodeList,
          name,
          dueDate,
          serviceType,
          documentType,
          composeType,
          attachmentFileList,
          sourceFileList,
          remark,
          supplierId,
        } = data

        console.log('attachmentFileList :>> ', attachmentFileList)

        this.sourceFileList = sourceFileList.map((v) => ({
          uid: uuid(),
          name: v.name,
          status: 'done',
          percent: 100,
          url: v.url,
        }))

        this.form = {
          id,
          productLineId: productLineId || undefined,
          sourceCode: sourceCode || undefined,
          targetCodeList: targetCodeList ? targetCodeList.split(',') : [],
          name: name || undefined,
          dueDate: dueDate || undefined,
          serviceType: serviceType || undefined,
          documentType: documentType || undefined,
          remark: remark || undefined,
          supplierId,
          composeType: Boolean(composeType),
          attachmentFileList,
        }
        this.loading = false
      } catch (err) {
        this.loading = false
        this.$httpNotify(err)
      }
    },
    // supplierId: this.supplierList.includes(supplierId) ? supplierId : undefined,
    //         attachmentFileList: attachmentFileList
    //           .filter((v) => v.tag === 1)
    //           .map((v) => ({
    //             uid: uuid(),
    //             name: v.name,
    //             status: 'done',
    //             percent: 100,
    //             url: v.url,
    //           })),

    // 保存草稿箱
    async handleSaveDraft() {
      try {
        this.loading = true
        await this.$http('processSave', this.getFormData())
        this.loading = false
        this.$success({
          title: this.$t('prompt.save_success'),
          icon: (h) => h(Icon, { props: { type: 'check-circle', theme: 'filled' } }),
          okText: this.$t('confirm'),
          onOk: () => {
            this.canLeave = true
            // 草稿箱
            this.$router.push({
              name: 'order_draftBox',
            })
          },
        })
      } catch (err) {
        this.loading = false
        this.$httpNotify(err)
      }
    },

    // 获取报价
    handleGetQuote() {
      this.$refs.orderForm.validate((valid) => {
        if (valid) {
          this.$confirm({
            title: this.$t('newOrder.get_quote'),
            content: this.$t('newOrder.get_quote_desc'),
            icon: (h) => h(Icon, { props: { type: 'exclamation-circle', theme: 'filled' } }),
            okText: this.$t('confirm'),
            cancelText: this.$t('cancel'),
            onOk: async () => {
              try {
                const id = await this.$http('processPresent', this.getFormData())
                this.canLeave = true
                // 跳订单详情
                this.$router.push({
                  path: this.$g.route.order_orderInfo,
                  query: {
                    id,
                    extraName: this.form.name,
                  },
                })
              } catch (err) {
                this.$httpNotify(err)
              }
            },
          })
        }
      })
    },
    // 获取供应商列表
    async getSupList() {
      try {
        const { sourceCode, targetCodeList, productLineId: supProductLineId } = this.form
        this.supplierList = await this.$http('getSupList', { sourceCode, targetCodeList, supProductLineId })
      } catch (err) {
        this.$httpNotify(err)
      }
    },
    labelFilterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  },
  beforeRouteLeave(to, from, next) {
    const sourceFileList = this.sourceFileList.filter((v) => v.status === 'done')
    if (sourceFileList.length && !this.canLeave && to.name !== 'login') {
      this.$confirm({
        title: this.$t('newOrder.prompt_save_draft'),
        icon: (h) => h(Icon, { props: { type: 'exclamation-circle', theme: 'filled' } }),
        okText: this.$t('confirm'),
        cancelText: this.$t('cancel'),
        onCancel: () => {
          next()
        },
        onOk: async () => {
          try {
            await this.$http('processSave', this.getFormData())
            this.canLeave = true
            next('/order/draftBox')
          } catch (err) {
            this.$httpNotify(err)
          }
        },
      })
    } else {
      next()
    }
  },
}
</script>
